import React, { Component } from "react";
import { Header, Message } from "semantic-ui-react";
// import * as Scroll from "react-scroll";
import moment from "moment";
import "./msgs.css";
// var scroll = Scroll.animateScroll;
class MessageList extends Component {
  markasread() {
    if (this.props.msgindex === this.props.messageindex) {
      let unreadarray = this.props.messages.filter(
        message => message.readind === 0
      );
      unreadarray = unreadarray.map(message => {
        return message.id;
      });
      this.props.handleread(unreadarray);
    }
  }
  componentDidUpdate(prevProps, prevState) {
    if (this.props.message) {
      let objDiv = document.getElementById("messagelist");
      objDiv.scrollTop = objDiv.scrollHeight;
      // scroll.scrollToBottom({
      //   containerId: "messagelist"
      // });
    }
  }
  componentDidMount() {
    if (this.props.message) {
      let objDiv = document.getElementById("messagelist");
      objDiv.scrollTop = objDiv.scrollHeight;
      // scroll.scrollToBottom({
      //   containerId: "messagelist"
      // });
    }
  }

  genmessages() {
    if (this.props.message && this.props.emp) {
      let messages = this.props.messages.sort((a, b) =>
        moment.utc(a.createdAt).diff(moment.utc(b.createdAt))
      );
      return messages.map(msg => {
        if (msg.fromemp === this.props.myempnumber) {
          return <Message color="teal">{msg.message}</Message>;
        } else {
          return (
            <Message
              header={this.props.emp.firstname + ":"}
              warning={!msg.readind}
              content={msg.message}
            />
          );
        }
      });
    } else if (this.props.alert) {
      return this.props.messages.map(msg => {
        return (
          <Message
            header={msg.subject + ":"}
            warning={!msg.readind}
            content={msg.message}
          />
        );
      });
    }
  }
  render() {
    var divref = this.props.message ? "msglst" : "none";
    var message_lst;
    if (this.props.messages) {
      if (this.props.message) {
        var msg_lst = (
          <div id="messagelist" ref={"msglst"}>
            {this.genmessages()}
          </div>
        );
        // msg_lst.scrollTop = msg_lst.scrollHeight;
        message_lst = (
          <div>
            <Header as="h2">{this.props.emp.firstname}</Header>
            {msg_lst}
          </div>
        );
      } else {
        message_lst = <div id="messagelist">{this.genmessages()}</div>;
      }
    } else {
      message_lst = <div />;
    }
    return <div>{message_lst}</div>;
  }
}
export default MessageList;



// WEBPACK FOOTER //
// ./src/components/messaging/messagelist.js